import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-products-overview-skeleton',
  templateUrl: './products-overview-skeleton.component.html',
  styleUrls: ['./products-overview-skeleton.component.css']
})
export class ProductsOverviewSkeletonComponent {

  // since they are loading the product on this point and have no .length we just have to do it with a hardcoded number...
  numberOfProducts(length: number): number[] {
    return Array.from({ length }, (_, index) => index);
  }

  skeletonItems = [
    { class: 'nes-w-5/12 nes-h-4 nes-mb-5', shape: 'heading' },
    { class: 'nes-w-6/12 nes-h-4 nes-mb-3 nes-ml-5', shape: 'heading' },
    { class: 'nes-w-5/12 nes-h-4 nes-mb-3 nes-ml-5', shape: 'heading' },
    { class: 'nes-w-6/12 nes-h-4 nes-mb-3 nes-ml-5', shape: 'heading' },
    { class: 'nes-w-8/12 nes-h-4 nes-mb-3 nes-ml-5', shape: 'heading' },
    { class: 'nes-w-4/12 nes-h-4 nes-mb-3 nes-ml-5', shape: 'heading' },
  ];

}
